import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomLink from '@bitComponents/unifiedComponents/CustomLink';
import './Card.scss';

export const BORDER_KIND = {
  LINE: 'line',
  ROUNDED: 'rounded',
  FULL_ROUNDED: 'fullRounded',
  NONE: 'none',
};

export const BORDER_COLOR = {
  WHITE: 'white',
  TRANSPARENT: 'transparent',
  BLACK: 'black',
  GREY_3: 'grey3',
};

export const BG_COLOR = {
  WHITE: 'white',
  TRANSPARENT: 'transparent',
  BLACK: 'black',
};

export const SHADOW_KIND = {
  SHADOW1: 'shadow1',
  NONE: 'none',
};

export const BAND_TITLE_COLOR = {
  NO: 'no',
  EGG: 'egg',
  ORANGE: 'orange',
  PURPLE: 'purple',
  BLUE: 'blue',
  GREEN: 'green',
};

class Card extends Component {
  constructor(props) {
    super(props);
    const { selected } = props;
    this.state = {
      selected,
    };
  }

  getBorderCss = (border) => {
    return ` Card_borderKind--border-${border}`;
  };

  getBorderColorCss = (borderColor) => {
    return ` Card_borderColor--${borderColor}`;
  };

  getCssShadow = (shadow) => {
    return ` Card_shadow--${shadow}`;
  };

  handleClick = () => {
    const { selected } = this.state;
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }
    this.setState({
      selected: !selected,
    });
  };

  render() {
    const { selected } = this.state;
    const {
      className,
      bandTitleColor,
      children,
      border,
      bgColor,
      borderColor,
      shadow,
      onClick,
      taggingInfo,
      isClickable,
      accInfo,
    } = this.props;

    if (!children) {
      return null;
    }

    const selectedCss = selected ? ' selected' : '';
    const bandTitleExist =
      bandTitleColor && bandTitleColor !== BAND_TITLE_COLOR.NO;
    const isTherBandColor = bandTitleExist ? ' CardWidthbandTitleColor' : '';
    const cssCardBackgroundColor = bgColor ? ` Card_bgColor--${bgColor}` : '';
    const cssBorderColor = this.getBorderColorCss(borderColor);
    const cssShadow = this.getCssShadow(shadow);
    const cssClick = !onClick ? 'defaultCursor' : '';

    return (
      <div
        className={`Card${isTherBandColor}${selectedCss}${cssCardBackgroundColor}${cssBorderColor}${this.getBorderCss(
          border,
        )}${cssShadow} ${cssClick} ${className}`}
      >
        {bandTitleExist && (
          <div
            className={`bandTitleColor bandTitleColor_color--${bandTitleColor}`}
          />
        )}
        <div className="cardContent">{children && children}</div>
        {isClickable && (
          <CustomLink
            taggingInfo={taggingInfo}
            isBlockElement
            onClick={this.handleClick}
            className="cardLink"
            accInfo={accInfo}
          />
        )}
      </div>
    );
  }
}

Card.propTypes = {
  /**
   * {
   *  "info": "Define el className del componente",
   *  "kind": "playground",
   *  "beautifulName": "ClassName"
   * }
   */
  className: PropTypes.string,
  /**
   * {
   *  "info": "Define el children del componente",
   *  "kind": "playground",
   *  "beautifulName": "Children"
   * }
   */
  children: PropTypes.node,
  /**
   * {
   *  "info": "Color del título del componente",
   *  "kind": "both",
   *  "beautifulName": "Color título"
   * }
   */
  bandTitleColor: PropTypes.oneOf([
    BAND_TITLE_COLOR.NO,
    BAND_TITLE_COLOR.EGG,
    BAND_TITLE_COLOR.ORANGE,
    BAND_TITLE_COLOR.PURPLE,
    BAND_TITLE_COLOR.BLUE,
    BAND_TITLE_COLOR.GREEN,
  ]),
  /**
   * {
   *  "info": "Color del fondo del componente",
   *  "kind": "both",
   *  "beautifulName": "Color fondo"
   * }
   */
  bgColor: PropTypes.oneOf([
    BG_COLOR.WHITE,
    BG_COLOR.TRANSPARENT,
    BG_COLOR.BLACK,
  ]),
  /**
   * {
   *  "info": "Define el tipo de border del componente",
   *  "kind": "both",
   *  "beautifulName": "Tipo border"
   * }
   */
  border: PropTypes.oneOf([
    BORDER_KIND.LINE,
    BORDER_KIND.NONE,
    BORDER_KIND.ROUNDED,
    BORDER_KIND.FULL_ROUNDED,
  ]),
  /**
   * {
   *  "info": "Define el color del border del componente",
   *  "kind": "both",
   *  "beautifulName": "Color border"
   * }
   */
  borderColor: PropTypes.oneOf([
    BORDER_COLOR.WHITE,
    BORDER_COLOR.BLACK,
    BORDER_COLOR.TRANSPARENT,
    BORDER_COLOR.GREY_3,
  ]),
  /**
   * {
   *  "info": "Define el tipo de sombra del componente",
   *  "kind": "both",
   *  "beautifulName": "Tipo sombra"
   * }
   */
  shadow: PropTypes.oneOf([SHADOW_KIND.NONE, SHADOW_KIND.SHADOW1]),
  /**
   * {
   *  "info": "Define si el componente esta seleccionado o no",
   *  "kind": "both",
   *  "beautifulName": "Seleccionado"
   * }
   */
  selected: PropTypes.bool,
  /**
   * {
   *  "info": "Define si el componente se puede clickar",
   *  "kind": "both",
   *  "beautifulName": "Seleccionado"
   * }
   */
  isClickable: PropTypes.bool,
  accInfo: PropTypes.object,
};

Card.defaultProps = {
  className: '',
  children: null,
  bgColor: BG_COLOR.WHITE,
  bandTitleColor: BAND_TITLE_COLOR.NO,
  selected: false,
  border: BORDER_KIND.NONE,
  borderColor: BORDER_COLOR.BLACK,
  shadow: SHADOW_KIND.SHADOW1,
  isClickable: true,
  accInfo: null,
};

export default Card;
